module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-ppt-fill-e5e17044.svg";